import { ShiftTypeEnum } from '@umss/shared/utils';
import { ShiftNeed } from '../models/shift-need.model';

/**
 * Resolves the bonus amount for a shift need.
 *
 * The bonus is the extra amount the facility added on top of their configured
 * rate when creating the shift.
 *
 * Formula:
 *   bonus = hourlyRate - configuredRate
 *
 * where configuredRate comes from rateInfo:
 *   - Urgent shifts: facilityUrgentHourlyRate
 *   - Regular shifts: facilityNormalHourlyRate
 *
 * Returns null when rateInfo is unavailable, the configured rate is unknown,
 * or no bonus was added (bonus <= 0).
 */
export function resolveShiftBonus(shiftNeed: ShiftNeed): number | null {
  const { hourlyRate, shiftType, rateInfo } = shiftNeed;

  if (!rateInfo) return null;

  const isUrgent = shiftType === ShiftTypeEnum.Urgent;
  const configuredRate = isUrgent
    ? rateInfo.facilityUrgentHourlyRate
    : rateInfo.facilityNormalHourlyRate;

  if (configuredRate == null) return null;

  const bonus = Number(hourlyRate) - Number(configuredRate);
  return bonus > 0 ? bonus : null;
}
